// extracted by mini-css-extract-plugin
export default {"container":"methodology_container__64Vla","block":"methodology_block__iCtWk","text":"methodology_text__cYVnk","submit__btn":"methodology_submit__btn__DAeiq"};